export const DAO_CODE = 'DASHBOARD_ADMIN' + '_DAO';
